import * as React from "react"
import { useTranslation } from "react-i18next"

import DeleteButton from "Catalog/Edit/shared/components/CatalogToolbar/DeleteButton"
import NewButton from "Catalog/Edit/shared/components/CatalogToolbar/NewButton"
import CatalogToolbar from "Catalog/shared/components/CatalogToolbar"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICategoryOrProduct, isCategory } from "shared/hubrise/models"
import { Category as CategoryUtil } from "shared/hubrise/utils"

interface ToolbarProps {
  categoryOrProduct?: ICategoryOrProduct
}

const Toolbar = ({ categoryOrProduct }: ToolbarProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()
  const { editor, catalog } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleCreateProduct = (name: string): void => {
    if (categoryOrProduct) {
      const product = editor.product.add(categoryOrProduct, { name })
      navigate(catalogNavigation.editPath("product", product.id))
    }
  }

  const handleCreateCategory = (name: string): void => {
    const category = editor.category.add(categoryOrProduct, { name })
    navigate(catalogNavigation.editPath("category", category.id))
  }

  const handleDelete = (categoryOrProduct: ICategoryOrProduct): void => {
    if (isCategory(categoryOrProduct)) {
      const nextCategory = CategoryUtil.next(catalog, catalogNavigation.lastCategoryOrProduct)
      navigate(
        nextCategory ? catalogNavigation.editPath("category", nextCategory.id) : catalogNavigation.editPath("products"),
      )
    } else {
      navigate(catalogNavigation.editNextPath("products"))
    }
    editor.categoryOrProduct.delete(categoryOrProduct)
  }

  const commandActions = (
    <>
      <NewButton
        handleCreate={handleCreateProduct}
        labelAndTitle={t("toolbar.new.product")}
        disabled={!categoryOrProduct}
      />
      <NewButton handleCreate={handleCreateCategory} labelAndTitle={t("toolbar.new.category")} />
      <DeleteButton item={categoryOrProduct} handleDelete={handleDelete} />
    </>
  )

  return <CatalogToolbar commandActions={commandActions} />
}

export default Toolbar
